import { render, staticRenderFns } from "./InstitutionGroups.vue?vue&type=template&id=39c1b6aa&scoped=true&"
import script from "./InstitutionGroups.vue?vue&type=script&lang=js&"
export * from "./InstitutionGroups.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionGroups.vue?vue&type=style&index=0&id=39c1b6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1b6aa",
  null
  
)

export default component.exports